export default class TimeType {
  static ORDER = "ORDER";
  static PAY = "PAY";
  static PRINT = "PRINT";
  static SHIP = "SHIP";
}
